/**
 * @module websocket.event.handlers.pilots.pilot-added
 */
import { store } from '../../../../state/store'
import { setPilotListUpdated } from '../../../../state/websocket.slice'

export default function handlePilotAdded(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handlePilotAdded', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setPilotListUpdated(data))
  }
} 